import React, { Component } from 'react';
import axios from 'axios';
import { CustomNav } from '../Components/CustomNav';
import { RosterTable } from '../Components/RosterTable';
import { PlayerCard } from '../Components/PlayerCard';
import { NonRosteredTable } from '../Components/NonRosteredTable';
import { makeData } from '../Utility/utility.js';
import './TeamManagement.css';
import { teamsData } from '../Pages/dataUrls';
import { AppContext } from '../Pages/App';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';
import { render } from 'react-dom';
import './RosterTable.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { getHenriStyle, round } from '../Utility/utility.js';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { ScenarioHeader } from '../Components/ScenarioHeader';
import { ResponseSpinner } from '../Components/ResponseSpinner';
//let homeTeam = require('../Mock/team-management-caps-pos.json');
//let awayTeam = require('../Mock/team-management-pit.json');
//let awayTeam2 = require('../Mock/reorder-positions.json');x

const teamUrl = React.createContext(apiServerUrl + '/team_players?team=');
const playerUrl = React.createContext(apiServerUrl + '/player_card?player_id=');

// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}`,
    content: `item ${k + offset}`
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  //console.log("after splicing" + JSON.stringify(result));
  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  console.log(source);
  console.log(destination);
  console.log(droppableSource);
  console.log(droppableDestination);
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const grid = 8;

class TeamManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prospects: makeData(),
      selectedPlayer: '',
      selectedPlayerStats: [],
      playerListHome: [],
      playerListAway: [],
      nonRostered: [],
      injuryList: [],
      suspensionList: [],
      homeTeam: jwtTeam(),
      //homeTeam: 'EDM',
      awayTeam: 'PIT',
      requestState: ''
    };
    this.toggleActive = this.toggleActive.bind(this);
    this.addPlayer = this.addPlayer.bind(this);
    this.saveRoster = this.saveRoster.bind(this);
    this.lockerRoom = this.lockerRoom.bind(this);
  }

  componentDidUpdate() {
    let currentComponent = this;
    console.log(this.state);
    let homeRes = this.state.playerListHomeUnfiltered;
    if (this.state.newTeam) {
      currentComponent.setState({
        activeTeamLeftWing: homeRes.data.players
          .filter(
            x => x.depth_chart_position == 'LW' && x.roster_status == 'ROSTERED'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        activeTeamCenter: homeRes.data.players
          .filter(
            x => x.depth_chart_position == 'C' && x.roster_status == 'ROSTERED'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        activeTeamRightWing: homeRes.data.players
          .filter(
            x => x.depth_chart_position == 'RW' && x.roster_status == 'ROSTERED'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        activeTeamLeftD: homeRes.data.players
          .filter(
            x => x.depth_chart_position == 'LD' && x.roster_status == 'ROSTERED'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        activeTeamRightD: homeRes.data.players
          .filter(
            x => x.depth_chart_position == 'RD' && x.roster_status == 'ROSTERED'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        activeTeamGoalies: homeRes.data.players
          .filter(
            x => x.depth_chart_position == 'G' && x.roster_status == 'ROSTERED'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        nonRosteredLeftWing: homeRes.data.players
          .filter(
            x =>
              x.depth_chart_position == 'LW' && x.roster_status == 'NON-ROSTER'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        nonRosteredCenter: homeRes.data.players
          .filter(
            x =>
              x.depth_chart_position == 'C' && x.roster_status == 'NON-ROSTER'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        nonRosteredRightWing: homeRes.data.players
          .filter(
            x =>
              x.depth_chart_position == 'RW' && x.roster_status == 'NON-ROSTER'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        nonRosteredLeftD: homeRes.data.players
          .filter(
            x =>
              x.depth_chart_position == 'LD' && x.roster_status == 'NON-ROSTER'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        nonRosteredRightD: homeRes.data.players
          .filter(
            x =>
              x.depth_chart_position == 'RD' && x.roster_status == 'NON-ROSTER'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        nonRosteredGoalies: homeRes.data.players
          .filter(
            x =>
              x.depth_chart_position == 'G' && x.roster_status == 'NON-ROSTER'
          )
          .sort((a, b) => {
            var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
              keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          }),
        reserves: homeRes.data.players.filter(
          x => x.roster_status == 'RESERVE'
        ),
        injuryList: homeRes.data.players.filter(
          x => x.roster_status == 'INJURED'
        ),
        suspensionList: homeRes.data.players.filter(
          x => x.roster_status == 'SUSPENDED'
        ),
        newList: homeRes.data.players.filter(x => x.roster_status == 'NEW'),
        activeTeamForwardScores: [],
        activeTeamOtherScores: [],
        nonRosteredForwardScores: [],
        nonRosteredOtherScores: [],
        newTeam: false
      });
      this.calculateLineScore();
    }
  }
  //`component
  componentWillMount() {
    let currentComponent = this;
    axios
      .all([
        axios.get(
          apiServerUrl + '/team_players?team=' + this.state.homeTeam,
          requestOptions()
        )
      ])
      .then(
        axios.spread(homeRes => {
          //console.log(homeRes.data);
          //console.log(awayRes.data);
          if (homeRes.data) {
            currentComponent.setState({
              playerListHome: homeRes.data.players,
              activeTeam: homeRes.data.players,
              activeTeamLeftWing: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'LW' &&
                    x.roster_status == 'ROSTERED'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              activeTeamCenter: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'C' &&
                    x.roster_status == 'ROSTERED'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              activeTeamRightWing: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'RW' &&
                    x.roster_status == 'ROSTERED'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              activeTeamLeftD: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'LD' &&
                    x.roster_status == 'ROSTERED'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              activeTeamRightD: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'RD' &&
                    x.roster_status == 'ROSTERED'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              activeTeamGoalies: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'G' &&
                    x.roster_status == 'ROSTERED'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              nonRosteredLeftWing: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'LW' &&
                    x.roster_status == 'NON-ROSTER'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              nonRosteredCenter: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'C' &&
                    x.roster_status == 'NON-ROSTER'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              nonRosteredRightWing: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'RW' &&
                    x.roster_status == 'NON-ROSTER'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              nonRosteredLeftD: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'LD' &&
                    x.roster_status == 'NON-ROSTER'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              nonRosteredRightD: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'RD' &&
                    x.roster_status == 'NON-ROSTER'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              nonRosteredGoalies: homeRes.data.players
                .filter(
                  x =>
                    x.depth_chart_position == 'G' &&
                    x.roster_status == 'NON-ROSTER'
                )
                .sort((a, b) => {
                  var keyA = a.depth_chart_rank ? a.depth_chart_rank : 99,
                    keyB = b.depth_chart_rank ? b.depth_chart_rank : 99;
                  // Compare the 2 dates
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                  return 0;
                }),
              reserves: homeRes.data.players.filter(
                x => x.roster_status == 'RESERVE'
              ),
              injuryList: homeRes.data.players.filter(
                x => x.roster_status == 'INJURED'
              ),
              suspensionList: homeRes.data.players.filter(
                x => x.roster_status == 'SUSPENDED'
              ),
              newList: homeRes.data.players.filter(
                x => x.roster_status == 'NEW'
              ),
              activeTeamForwardScores: [],
              activeTeamOtherScores: [],
              nonRosteredForwardScores: [],
              nonRosteredOtherScores: []
              //nonRostered: homeRes.data.players,
              //reserves: homeRes.data.players,

              /*
              nonRostered: homeRes.data.players.filter(
                x => x.roster_status == 'NON-ROSTER'
              ),
              playerListAway: awayRes.data.players*/
            });
            console.log(this.state.activeTeamCenter);
            this.calculateLineScore();
            //console.log(test);
          }
        })
      );
  }

  addPlayer(data) {
    //console.log("adding" + data);
  }

  changeTeam(e, side) {
    let currentComponent = this;
    let value = e.target.value;
    let url = apiServerUrl + '/team_players?team=' + e.target.value;
    // Make a request for a user with a given ID
    axios
      .get(url, requestOptions())
      .then(function(homeRes) {
        //  //console.log("called out " + JSON.stringify(response.data.players));
        currentComponent.setState({
          playerListHome: homeRes.data.players,
          playerListHomeUnfiltered: homeRes,
          homeTeam: value,
          newTeam: true
        });
        console.log('test');
        this.calculateLineScore();
      })
      .catch(function(error) {
        //console.log(error);
      });
  }

  toggleActive(e, example) {
    console.log(e);
    let incomingPlayerID = e;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl + '/player_card?player_id=' + incomingPlayerID,
        requestOptions()
      )
      .then(function(response) {
        console.log(response.data);
        if (response.data) {
          currentComponent.setState({
            selectedPlayer: response.data
          });
        }
      })
      .catch(function(error) {
        //console.log(error);
      });
  }

  lockerRoom() {
    this.props.dispatch(push('/depth'));
  }
  // lockerRoom = () => dispatch => {
  //   /* do something before redirection */
  //   console.log('navigating');
  //   dispatch(push('/team'));
  // };
  saveRoster() {
    let currentComponent = this;
    currentComponent.setState({
      requestState: 'loading'
    });

    let players = [];
    let rosters = [
      'leftWing',
      'rightWing',
      'center',
      'leftD',
      'rightD',
      'goalies',
      'nonRoster'
    ];
    console.log(this.state.activeTeamLeftWing.length);
    for (let i = 0; i < this.state.activeTeamLeftWing.length; i++) {
      players.push(this.state.activeTeamLeftWing[i]);
    }
    for (let i = 0; i < this.state.activeTeamRightWing.length; i++) {
      players.push(this.state.activeTeamRightWing[i]);
    }
    for (let i = 0; i < this.state.activeTeamCenter.length; i++) {
      players.push(this.state.activeTeamCenter[i]);
    }
    for (let i = 0; i < this.state.activeTeamLeftD.length; i++) {
      players.push(this.state.activeTeamLeftD[i]);
    }
    for (let i = 0; i < this.state.activeTeamRightD.length; i++) {
      players.push(this.state.activeTeamRightD[i]);
    }
    for (let i = 0; i < this.state.activeTeamGoalies.length; i++) {
      players.push(this.state.activeTeamGoalies[i]);
    }

    for (let i = 0; i < this.state.nonRosteredLeftWing.length; i++) {
      players.push(this.state.nonRosteredLeftWing[i]);
    }
    for (let i = 0; i < this.state.nonRosteredRightWing.length; i++) {
      players.push(this.state.nonRosteredRightWing[i]);
    }
    for (let i = 0; i < this.state.nonRosteredCenter.length; i++) {
      players.push(this.state.nonRosteredCenter[i]);
    }
    for (let i = 0; i < this.state.nonRosteredLeftD.length; i++) {
      players.push(this.state.nonRosteredLeftD[i]);
    }
    for (let i = 0; i < this.state.nonRosteredRightD.length; i++) {
      players.push(this.state.nonRosteredRightD[i]);
    }
    for (let i = 0; i < this.state.nonRosteredGoalies.length; i++) {
      players.push(this.state.nonRosteredGoalies[i]);
    }

    for (let i = 0; i < this.state.reserves.length; i++) {
      players.push(this.state.reserves[i]);
    }
    for (let i = 0; i < this.state.injuryList.length; i++) {
      players.push(this.state.injuryList[i]);
    }
    for (let i = 0; i < this.state.suspensionList.length; i++) {
      players.push(this.state.suspensionList[i]);
    }
    console.log('saving');
    console.log(this.state.activeTeamLeftWing);
    console.log(JSON.stringify(players));
    console.log(players);
    axios
      .post(
        apiServerUrl + '/save_roster',
        {
          depth_chart: players
        },
        requestOptions()
      )
      .then(function(response) {
        console.log(response);
        currentComponent.setState({
          requestState: 'success'
        });
        setTimeout(function() {
          currentComponent.setState({
            requestState: ''
          });
        }, 1500);
      })
      .catch(function(error) {
        console.log(error);
        currentComponent.setState({
          requestState: 'failure'
        });
        setTimeout(function() {
          currentComponent.setState({
            requestState: ''
          });
        }, 1500);
      });
  }
  calculateLineScore() {
    let activeTeamForwardScores = [];
    for (
      let i = 0;
      i <
      Math.max(
        this.state.activeTeamLeftWing.length,
        this.state.activeTeamRightWing.length,
        this.state.activeTeamCenter.length
      );
      i++
    ) {
      let sum = 0;
      let numScores = 0;
      if (this.state.activeTeamLeftWing[i]) {
        ////console.log("adding " + this.state.leftWing[i].henri + this.state.leftWing[i].name);
        sum += this.state.activeTeamLeftWing[i].cap_hit;
        numScores++;
      }
      if (this.state.activeTeamRightWing[i]) {
        ////console.log("adding " + this.state.activeTeamRightWing[i].henri + this.state.activeTeamRightWing[i].name);
        sum += this.state.activeTeamRightWing[i].cap_hit;
        numScores++;
      }
      if (this.state.activeTeamCenter[i]) {
        ////console.log("adding " + this.state.activeTeamCenter[i].henri + this.state.activeTeamCenter[i].name);
        sum += this.state.activeTeamCenter[i].cap_hit;
        numScores++;
      }
      ////console.log("sum" + sum.toFixed(2));
      //sum = (sum.toFixed(2) / numScores).toFixed(2);
      activeTeamForwardScores.push(sum);
    }
    let activeTeamOtherScores = [];
    for (
      let i = 0;
      i <
      Math.max(
        this.state.activeTeamLeftD.length,
        this.state.activeTeamRightD.length
      );
      i++
    ) {
      let sum = 0;
      let numScores = 0;
      if (this.state.activeTeamLeftD[i]) {
        ////console.log("adding " + this.state.activeTeamLeftD[i].henri + this.state.activeTeamLeftD[i].name);
        sum += this.state.activeTeamLeftD[i].cap_hit;
        numScores++;
      }
      if (this.state.activeTeamRightD[i]) {
        ////console.log("adding " + this.state.activeTeamRightD[i].henri + this.state.activeTeamRightD[i].name);
        sum += this.state.activeTeamRightD[i].cap_hit;
        numScores++;
      }
      ////console.log("sum" + sum.toFixed(2));
      //sum = (sum.toFixed(2) / numScores).toFixed(2);
      activeTeamOtherScores.push(sum);
    }

    ///////////////////////////
    // Calculate non rostered//
    ///////////////////////////
    let nonRosteredForwardScores = [];
    for (
      let i = 0;
      i <
      Math.max(
        this.state.nonRosteredLeftWing.length,
        this.state.nonRosteredRightWing.length,
        this.state.nonRosteredCenter.length
      );
      i++
    ) {
      let sum = 0;
      let numScores = 0;
      if (this.state.nonRosteredLeftWing[i]) {
        ////console.log("adding " + this.state.leftWing[i].henri + this.state.leftWing[i].name);
        sum += this.state.nonRosteredLeftWing[i].cap_hit;
        numScores++;
      }
      if (this.state.nonRosteredRightWing[i]) {
        ////console.log("adding " + this.state.activeTeamRightWing[i].henri + this.state.activeTeamRightWing[i].name);
        sum += this.state.nonRosteredRightWing[i].cap_hit;
        numScores++;
      }
      if (this.state.nonRosteredCenter[i]) {
        ////console.log("adding " + this.state.activeTeamCenter[i].henri + this.state.activeTeamCenter[i].name);
        sum += this.state.nonRosteredCenter[i].cap_hit;
        numScores++;
      }
      ////console.log("sum" + sum.toFixed(2));
      //sum = (sum.toFixed(2) / numScores).toFixed(2);
      nonRosteredForwardScores.push(sum);
    }
    let nonRosteredOtherScores = [];
    for (
      let i = 0;
      i <
      Math.max(
        this.state.nonRosteredLeftD.length,
        this.state.nonRosteredRightD.length
      );
      i++
    ) {
      let sum = 0;
      let numScores = 0;
      if (this.state.nonRosteredLeftD[i]) {
        ////console.log("adding " + this.state.activeTeamLeftD[i].henri + this.state.activeTeamLeftD[i].name);
        sum += this.state.nonRosteredLeftD[i].cap_hit;
        numScores++;
      }
      if (this.state.nonRosteredRightD[i]) {
        ////console.log("adding " + this.state.activeTeamRightD[i].henri + this.state.activeTeamRightD[i].name);
        sum += this.state.nonRosteredRightD[i].cap_hit;
        numScores++;
      }
      ////console.log("sum" + sum.toFixed(2));
      //sum = (sum.toFixed(2) / numScores).toFixed(2);
      nonRosteredOtherScores.push(sum);
    }

    //add all line scores
    this.setState({
      activeTeamForwardScores: activeTeamForwardScores,
      activeTeamOtherScores: activeTeamOtherScores,
      nonRosteredForwardScores: nonRosteredForwardScores,
      nonRosteredOtherScores: nonRosteredOtherScores
    });
  }
  handleClick() {
    //console.log("CLICKED");
  }
  id2List = {
    activeTeamLeftWing: 'activeTeamLeftWing',
    activeTeamCenter: 'activeTeamCenter',
    activeTeamRightWing: 'activeTeamRightWing',
    activeTeamLeftD: 'activeTeamLeftD',
    activeTeamRightD: 'activeTeamRightD',
    activeTeamGoalies: 'activeTeamGoalies',
    nonRosteredLeftWing: 'nonRosteredLeftWing',
    nonRosteredCenter: 'nonRosteredCenter',
    nonRosteredRightWing: 'nonRosteredRightWing',
    nonRosteredLeftD: 'nonRosteredLeftD',
    nonRosteredRightD: 'nonRosteredRightD',
    nonRosteredGoalies: 'nonRosteredGoalies',
    nonRoster: 'nonRoster',
    injuryList: 'injuryList',
    suspensionList: 'suspensionList',
    newList: 'newList'
  };

  id2Position = {
    activeTeamLeftWing: 'LW',
    activeTeamCenter: 'C',
    activeTeamRightWing: 'RW',
    activeTeamLeftD: 'LD',
    activeTeamRightD: 'RD',
    activeTeamGoalies: 'G',
    nonRosteredLeftWing: 'LW',
    nonRosteredCenter: 'C',
    nonRosteredRightWing: 'RW',
    nonRosteredLeftD: 'LD',
    nonRosteredRightD: 'RD',
    nonRosteredGoalies: 'G'
  };
  id2NonRosterPosition = {
    nonRosteredLeftWing: 'nonRoster',
    nonRosteredCenter: 'nonRoster',
    nonRosteredRightWing: 'nonRoster',
    nonRosteredLeftD: 'nonRoster',
    nonRosteredRightD: 'nonRoster',
    nonRosteredGoalies: 'nonRoster'
  };

  reIndex(players, position) {
    console.log('position is ' + position);
    const newArray = players.map((value, index, array) => {
      console.log(value, index, array);
      value.depth_chart_rank = index + 1;
      console.log('non moidifed posiiton' + position);
      console.log('moidifed posiiton' + this.id2Position[position]);
      if (this.id2NonRosterPosition[position] == 'nonRoster') {
        value.roster_status = 'NON-ROSTER';
        console.log('NON ROSTER');
        //Don't change em
        //value.depth_chart_position = position;
        value.depth_chart_position = this.id2Position[position];
      } else if (position == 'injuryList') {
        value.roster_status = 'INJURED';
        //Don't change em
        value.depth_chart_position = position;
        //value.depth_chart_position = this.id2Position[position];
      } else if (position == 'suspensionList') {
        value.roster_status = 'SUSPENDED';
        //Don't change em
        value.depth_chart_position = position;
        //value.depth_chart_position = this.id2Position[position];
      } else {
        value.roster_status = 'ROSTERED';
        console.log(position);
        console.log(this.id2Position[position]);
        value.depth_chart_position = this.id2Position[position];
      }
      return value;
    });
    console.log(newArray);
    return newArray;
  }
  getList = id => this.state[this.id2List[id]];

  onDragEnd = result => {
    const { source, destination } = result;
    console.log(source);
    console.log(source.droppableId);
    console.log(destination);

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { items };
      state = { droppableId: items };

      let example = [source.droppableId];

      console.log(source);
      console.log(example);
      this.setState({
        [example]: this.reIndex(items, example)
      });
    } else {
      console.log(source.droppableId);
      console.log(destination.droppableId);
      console.log(this.getList(source.droppableId));
      console.log(this.getList(destination.droppableId));
      console.log(source);
      console.log(destination);
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );
      console.log('result' + JSON.stringify(result));
      let example = Object.keys(result);
      console.log(example[0]);
      let test = example[0];
      let test2 = example[1];
      let result1 = result[test];
      let result2 = result[test2];
      this.setState({
        [example[0]]: this.reIndex(result1, example[0]),
        [example[1]]: this.reIndex(result2, example[1])
      });
    }
    //Update the linescores
    this.calculateLineScore();
  };

  /*Position	Color	Cumulative Minimum 	Cumulative Maximum
  Forward	Blue	18	~
  Forward	Green	12	17.99
  Forward	Yellow	7	11.99
  Forward	Red	0	6.99*/
  lineCellColorClass(value, position) {
    if (value == null) {
      return 'roster-grey-cell';
    }
    if (position == 'f') {
      if (
        value.split('m')[0] < 6.99 ||
        value.split('k')[0] < 1000 ||
        value == 'RED'
      ) {
        return 'roster-red-cell';
      } else if (value.split('m')[0] < 11.99 || value == 'YELLOW') {
        return 'roster-yellow-cell';
      } else if (value.split('m')[0] < 17.99 || value == 'GREEN') {
        return 'roster-green-cell';
      } else if (
        value.split('m')[0] > 18 ||
        value == 'BLUE' ||
        value == 'Blue'
      ) {
        return 'roster-blue-cell';
      } else {
        return 'roster-grey-cell';
      }
    } else if (position == 'd') {
      /*  Defense	Blue	11	~
      Defense	Green	8	10.99
      Defense	Yellow	4.5	7.99
      Defense	Red	0	4.4*/
      if (
        value.split('m')[0] < 4.4 ||
        value.split('k')[0] < 1000 ||
        value == 'RED'
      ) {
        return 'roster-red-cell';
      } else if (value.split('m')[0] < 7.99 || value == 'YELLOW') {
        return 'roster-yellow-cell';
      } else if (value.split('m')[0] < 10.99 || value == 'GREEN') {
        return 'roster-green-cell';
      } else if (
        value.split('m')[0] > 11 ||
        value == 'BLUE' ||
        value == 'Blue'
      ) {
        return 'roster-blue-cell';
      } else {
        return 'roster-grey-cell';
      }
    }
  }
  HenriCellColorClass(value) {
    if (value == null) {
      return 'roster-grey-cell';
    } else if (
      value.split('m')[0] < 2.0 ||
      value.split('k')[0] < 1000 ||
      value == 'RED'
    ) {
      return 'roster-red-cell';
    } else if (value.split('m')[0] < 5.0 || value == 'YELLOW') {
      return 'roster-yellow-cell';
    } else if (value.split('m')[0] < 7.0 || value == 'GREEN') {
      return 'roster-green-cell';
    } else if (
      value.split('m')[0] > 7.0 ||
      value == 'BLUE' ||
      value == 'Blue'
    ) {
      return 'roster-blue-cell';
    } else {
      return 'roster-grey-cell';
    }
  }
  render() {
    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <header className="nav">
            <CustomNav />
            <ScenarioHeader />
          </header>
          {this.state.playerListHome.length > 0 &&
            this.state.newList.length > 0 && (
              <div>
                <div className="roster-table-column-header">NEW PLAYERS</div>
                <Droppable droppableId="newList">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                      style={{ flexDirection: 'row' }}
                    >
                      {[]
                        .concat(this.state.newList)
                        .sort((a, b) => {
                          a = a.depth_chart_rank === null ? -Infinity : a;
                          b = b.depth_chart_rank === null ? -Infinity : b;
                          return a.depth_chart_rank > b.depth_chart_rank;
                        })
                        .map((item, index) => (
                          <Draggable
                            key={item.player_id}
                            draggableId={item.player_id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={
                                  'roster-table-cell-modified-new-players ' +
                                  this.HenriCellColorClass(round(item.henri))
                                }
                                style={{ maxWidth: '200px' }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                data-playerID={item.player_id}
                                onClick={this.toggleActive.bind(
                                  this,
                                  item.player_id
                                )}
                              >
                                {/*{this.HenriCellColor(item.henri)}*/}
                                <div className="roster-table-cell-top">
                                  <div>
                                    {' '}
                                    #{item.number} {item.first_name[0]}.{' '}
                                    {item.last_name}
                                  </div>
                                </div>
                                <div className="roster-table-cell-bottom">
                                  <div>
                                    ATOI: {Math.round(item.atoi * 100) / 100}
                                  </div>
                                  {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                  <div>
                                    CAP: $
                                    {item.cap_hit ? round(item.cap_hit) : 0}
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            )}

          <div className="team-flex-grid" style={{ marginTop: '1em' }}>
            {/* Left Side */}
            <div
              className="team-hds-container"
              style={{ flexDirection: 'column' }}
            >
              <div
                className="gutter-right"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flex: 1
                  }}
                >
                  <div className="team-hds-container-heading" style={{}}>
                    <span>{this.state.homeTeam}</span>
                  </div>
                  {this.state.homeTeam == jwtTeam() && (
                    <button
                      style={{
                        maxHeight: '35px',
                        fontSize: '13px',
                        marginBottom: '3px',
                        padding: '2px 6px 4px 6px'
                      }}
                      className="header-account-button"
                      onClick={this.lockerRoom}
                    >
                      Locker Room
                    </button>
                  )}
                  <button
                    style={{
                      maxHeight: '35px',
                      fontSize: '13px',
                      marginBottom: '3px',
                      padding: '2px 6px 4px 6px'
                    }}
                    className="header-account-button"
                    onClick={this.saveRoster}
                  >
                    Save Roster
                  </button>
                  <ResponseSpinner loading={this.state.requestState} />
                  <select
                    className="teamList"
                    style={{ alignSelf: 'flex-start' }}
                    onChange={e => this.changeTeam(e, 'left')}
                  >
                    <option key={'default'}>CHOOSE HOME TEAM</option>
                    <AppContext.Consumer>
                      {context =>
                        context.number.map(item => (
                          <option
                            key={item.abbreviation}
                            value={item.abbreviation}
                          >
                            {item.full_team_name}
                          </option>
                        ))
                      }
                    </AppContext.Consumer>
                  </select>
                </div>
                {this.state.playerListHome.length > 0 && (
                  <div>
                    <div className="roster" style={{ flex: 8 }}>
                      <div className="roster-table" style={{ flex: 8 }}>
                        <div className="roster-table-row">
                          <Droppable droppableId="activeTeamLeftWing">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  LEFT WING
                                </div>
                                {[]
                                  .concat(this.state.activeTeamLeftWing)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          data-playerID={item.player_id}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          {/*{this.HenriCellColor(item.henri)}*/}
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <Droppable droppableId="activeTeamCenter">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  CENTER
                                </div>
                                {[]
                                  .concat(this.state.activeTeamCenter)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <Droppable droppableId="activeTeamRightWing">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  RIGHT WING
                                </div>
                                {[]
                                  .concat(this.state.activeTeamRightWing)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <div className="roster-table-column-line-score">
                            <div className="roster-table-column-header">
                              CAP
                            </div>
                            {this.state.activeTeamForwardScores.map(item => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.lineCellColorClass(round(item), 'f')
                                }
                              >
                                <div>
                                  <strong>{round(item)}</strong>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="roster-table-row">
                          <Droppable droppableId="activeTeamLeftD">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  LEFT DEFENSE
                                </div>
                                {[]
                                  .concat(this.state.activeTeamLeftD)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>

                          <Droppable droppableId="activeTeamRightD">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  RIGHT DEFENSE
                                </div>
                                {[]
                                  .concat(this.state.activeTeamRightD)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <Droppable droppableId="activeTeamGoalies">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  GOALIES
                                </div>
                                {[]
                                  .concat(this.state.activeTeamGoalies)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          {/*<div className="roster-table-column">
                            <div className="roster-table-column-header">
                              GOALIES
                            </div>
                            {[]
                              .concat(this.state.activeTeamGoalies)
                              .sort((a, b) => {
                                a = a.depth_chart_rank === null ? -Infinity : a;
                                b = b.depth_chart_rank === null ? -Infinity : b;
                                return a.depth_chart_rank > b.depth_chart_rank;
                              })
                              .map((item, index) => (
                                <div
                                  className={
                                    'roster-table-cell-2 ' +
                                    this.HenriCellColorClass(round(item.henri))
                                  }
                                  key={item.player_id}
                                  onClick={this.toggleActive.bind(
                                    this,
                                    item.player_id
                                  )}
                                >
                                  <div className="roster-table-cell-top">
                                    <div>
                                      {' '}
                                      #{item.number} {item.first_name[0]}.{' '}
                                      {item.last_name}
                                    </div>
                                  </div>
                                  <div className="roster-table-cell-bottom">
                                    <div>
                                      ATOI: {Math.round(item.atoi * 100) / 100}
                                    </div>
                                    {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>
                                    <div>CAP: ${round(item.cap_hits.cap_hit)}</div>{' '}
                                  </div>
                                </div>
                              ))}
                          </div>
                         */}
                          <div className="roster-table-column-line-score">
                            <div className="roster-table-column-header">
                              CAP
                            </div>
                            {this.state.activeTeamOtherScores.map(item => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.lineCellColorClass(round(item), 'd')
                                }
                              >
                                <div>
                                  <strong>{round(item)}</strong>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-evenly'
                      }}
                    >
                      <div>}</div>
                    </div>
                    {/* Maybe put non rostered here */}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-evenly'
                      }}
                    >
                      <div
                        className="nonRostered gutter-right"
                        style={{ flex: 7, width: '100%' }}
                      >
                        <h4>
                          <strong>NON-ROSTERED PLAYERS</strong>
                        </h4>
                        <NonRosteredTable
                          filterable={false}
                          style={{ margin: 0 }}
                          showPagination={false}
                          data={this.state.reserves}
                          toggleActive={this.toggleActive}
                        />
                      </div>
                      <div
                        style={{
                          flex: 3,
                          backgroundColor: 'white',
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        <Droppable droppableId="injuryList">
                          {(provided, snapshot) => (
                            <div
                              className="roster-table-column"
                              ref={provided.innerRef}
                            >
                              <div className="roster-table-column-header">
                                INJURIES
                              </div>
                              {[]
                                .concat(this.state.injuryList)
                                .sort((a, b) => {
                                  a =
                                    a.depth_chart_rank === null ? -Infinity : a;
                                  b =
                                    b.depth_chart_rank === null ? -Infinity : b;
                                  return (
                                    a.depth_chart_rank > b.depth_chart_rank
                                  );
                                })
                                .map((item, index) => (
                                  <Draggable
                                    key={item.player_id}
                                    draggableId={item.player_id}
                                    index={index}
                                    style={{ minHeight: '50px' }}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className={
                                          'roster-table-cell-2 ' +
                                          this.HenriCellColorClass(
                                            round(item.henri)
                                          )
                                        }
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        onClick={this.toggleActive.bind(
                                          this,
                                          item.player_id
                                        )}
                                      >
                                        <div className="roster-table-cell-top">
                                          <div>
                                            {' '}
                                            #{item.number} {item.first_name[0]}.{' '}
                                            {item.last_name}
                                          </div>
                                        </div>
                                        <div className="roster-table-cell-bottom">
                                          <div>
                                            ATOI:{' '}
                                            {Math.round(item.atoi * 100) / 100}
                                          </div>
                                          {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                          <div>
                                            CAP: $
                                            {item.cap_hit
                                              ? round(item.cap_hit)
                                              : 0}
                                          </div>{' '}
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                        <Droppable droppableId="suspensionList">
                          {(provided, snapshot) => (
                            <div
                              className="roster-table-column"
                              ref={provided.innerRef}
                            >
                              <div className="roster-table-column-header">
                                SUSPENSIONS
                              </div>
                              {[]
                                .concat(this.state.suspensionList)
                                .sort((a, b) => {
                                  a =
                                    a.depth_chart_rank === null ? -Infinity : a;
                                  b =
                                    b.depth_chart_rank === null ? -Infinity : b;
                                  return (
                                    a.depth_chart_rank > b.depth_chart_rank
                                  );
                                })
                                .map((item, index) => (
                                  <Draggable
                                    key={item.player_id}
                                    draggableId={item.player_id}
                                    index={index}
                                    style={{ minHeight: '50px' }}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className={
                                          'roster-table-cell-2 ' +
                                          this.HenriCellColorClass(
                                            round(item.henri)
                                          )
                                        }
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        onClick={this.toggleActive.bind(
                                          this,
                                          item.player_id
                                        )}
                                      >
                                        <div className="roster-table-cell-top">
                                          <div>
                                            {' '}
                                            #{item.number} {item.first_name[0]}.{' '}
                                            {item.last_name}
                                          </div>
                                        </div>
                                        <div className="roster-table-cell-bottom">
                                          <div>
                                            ATOI:{' '}
                                            {Math.round(item.atoi * 100) / 100}
                                          </div>
                                          {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                          <div>
                                            CAP: $
                                            {item.cap_hit
                                              ? round(item.cap_hit)
                                              : 0}
                                          </div>{' '}
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Side */}
            <div
              className="team-hds-container"
              style={{ flexDirection: 'column' }}
            >
              <div
                className="gutter-right"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flex: 1
                  }}
                >
                  <div className="team-hds-container-heading" style={{}}>
                    <span>MINORS</span>
                  </div>
                  {/* <h3 class="h3" id="opponent">Opposing Team</h3>
                {/*}<select
                  className="teamList"
                  style={{ alignSelf: 'flex-start' }}
                  onChange={e => this.changeTeam(e, 'right')}
                >
                  <option>CHOOSE OPPOSING TEAM</option>
                  <AppContext.Consumer>
                    {context =>
                      context.number.map(item => (
                        <option value={item.abbreviation}>
                          {item.full_team_name}
                        </option>
                      ))
                    }
                  </AppContext.Consumer>
                </select>*/}
                </div>
                {this.state.playerListHome.length > 0 && (
                  <div>
                    <div className="roster" style={{ flex: 8 }}>
                      <div className="roster-table" style={{ flex: 8 }}>
                        <div className="roster-table-row">
                          <div
                            className="roster-table-column-line-score"
                            style={{ flex: 0.5 }}
                          >
                            <div className="roster-table-column-header">
                              CAP
                            </div>
                            {this.state.nonRosteredForwardScores.map(item => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.lineCellColorClass(round(item), 'f')
                                }
                              >
                                <div>
                                  <strong>{round(item)}</strong>
                                </div>
                              </div>
                            ))}
                          </div>

                          <Droppable droppableId="nonRosteredLeftWing">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  LEFT WING
                                </div>
                                {[]
                                  .concat(this.state.nonRosteredLeftWing)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          data-playerID={item.player_id}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          {/*{this.HenriCellColor(item.henri)}*/}
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <Droppable droppableId="nonRosteredCenter">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  CENTER
                                </div>
                                {[]
                                  .concat(this.state.nonRosteredCenter)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <Droppable droppableId="nonRosteredRightWing">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  RIGHT WING
                                </div>
                                {[]
                                  .concat(this.state.nonRosteredRightWing)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </div>
                        <div className="roster-table-row">
                          {this.state.nonRosteredOtherScores && (
                            <div className="roster-table-column-line-score">
                              <div className="roster-table-column-header">
                                CAP
                              </div>
                              {this.state.nonRosteredOtherScores.map(item => (
                                <div
                                  className={
                                    'roster-table-cell-2 ' +
                                    this.lineCellColorClass(round(item), 'd')
                                  }
                                >
                                  <div>
                                    <strong>{round(item)}</strong>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                          <Droppable droppableId="nonRosteredLeftD">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  LEFT DEFENSE
                                </div>
                                {[]
                                  .concat(this.state.nonRosteredLeftD)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>

                          <Droppable droppableId="nonRosteredRightD">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  RIGHT DEFENSE
                                </div>
                                {[]
                                  .concat(this.state.nonRosteredRightD)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          <Droppable droppableId="nonRosteredGoalies">
                            {(provided, snapshot) => (
                              <div
                                className="roster-table-column"
                                ref={provided.innerRef}
                              >
                                <div className="roster-table-column-header">
                                  GOALIES
                                </div>
                                {[]
                                  .concat(this.state.nonRosteredGoalies)
                                  .sort((a, b) => {
                                    a =
                                      a.depth_chart_rank === null
                                        ? -Infinity
                                        : a;
                                    b =
                                      b.depth_chart_rank === null
                                        ? -Infinity
                                        : b;
                                    return (
                                      a.depth_chart_rank > b.depth_chart_rank
                                    );
                                  })
                                  .map((item, index) => (
                                    <Draggable
                                      key={item.player_id}
                                      draggableId={item.player_id}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className={
                                            'roster-table-cell-2 ' +
                                            this.HenriCellColorClass(
                                              round(item.henri)
                                            )
                                          }
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          onClick={this.toggleActive.bind(
                                            this,
                                            item.player_id
                                          )}
                                        >
                                          <div className="roster-table-cell-top">
                                            <div>
                                              {' '}
                                              #{item.number}{' '}
                                              {item.first_name[0]}.{' '}
                                              {item.last_name}
                                            </div>
                                          </div>
                                          <div className="roster-table-cell-bottom">
                                            <div>
                                              ATOI:{' '}
                                              {Math.round(item.atoi * 100) /
                                                100}
                                            </div>
                                            {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                            <div>
                                              CAP: $
                                              {item.cap_hit
                                                ? round(item.cap_hit)
                                                : 0}
                                            </div>{' '}
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          {/*
                          <div className="roster-table-column">
                            <div className="roster-table-column-header">
                              GOALIES
                            </div>
                            {[]
                              .concat(this.state.nonRosteredGoalies)
                              .sort((a, b) => {
                                a = a.depth_chart_rank === null ? -Infinity : a;
                                b = b.depth_chart_rank === null ? -Infinity : b;
                                return a.depth_chart_rank > b.depth_chart_rank;
                              })
                              .map((item, index) => (
                                <div
                                  className={
                                    'roster-table-cell-2 ' +
                                    this.HenriCellColorClass(round(item.henri))
                                  }
                                  key={item.player_id}
                                  onClick={this.toggleActive.bind(
                                    this,
                                    item.player_id
                                  )}
                                >
                                  <div className="roster-table-cell-top">
                                    <div>
                                      {' '}
                                      #{item.number} {item.first_name[0]}.{' '}
                                      {item.last_name}
                                    </div>
                                  </div>
                                  <div className="roster-table-cell-bottom">
                                    <div>
                                      ATOI: {Math.round(item.atoi * 100) / 100}
                                    </div>
                                    {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>
                                    <div>CAP: ${round(item.cap_hits.cap_hit)}</div>{' '}
                                  </div>
                                </div>
                              ))}
                          </div>*/}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-evenly'
                      }}
                    >
                      <div>}</div>
                    </div>
                    {this.state.selectedPlayer && (
                      <PlayerCard selectedPlayer={this.state.selectedPlayer} />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/*<div className="team-flex-grid" style={{marginBottom: '1em'}}>
          <div className="hds-container" style={{ flex: 4 }}>
            <div className="nonRostered gutter-right" style={{ flex: 1 }}>
              <h4><strong>NON-ROSTERED PLAYERS</strong></h4>
                <NonRosteredTable filterable={false} style={{ margin: 0 }} showPagination={false} data={this.state.reserves} toggleActive={this.toggleActive}/>
               </div>
          </div>
          {/*<div className="player gutter-right" style={{ flex: 6 }}>
              {this.state.selectedPlayer && <PlayerCard selectedPlayer={this.state.selectedPlayer}/>}
          </div>
        {/*</div>*/}
        </DragDropContext>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedTeamManagement = connect(mapStateToProps)(TeamManagement);
export { connectedTeamManagement as TeamManagement };



// WEBPACK FOOTER //
// ./src/Pages/TeamManagement.js